import { DISPLAY_NOTIFICATION } from '@/store/actions'
import Store from '@/store'

/* When deploying a new version of the code, the webpack generates new file hashes for each changed
 * 'chunk'.  Since we are loading components dynamically, the previous chunks may not exist anymore
 * when the user is navigating in the interface, so the JS files are failing to load.
 *
 * This aims to refresh the page in this particular case, but if the chunk is unavailable for some
 * other reason after the page is refreshed (ex: the CDN is temporarily failing), we should prevent
 * an infinite refresh loop and warn the user instead.
 */
const EmptyComponent = {
  render() {},
}

const storageKey = 'km_failed_to_load_chunk'
export default function loadChunk(promise) {
  return promise.catch(e => {
    const lastComponentFailure = localStorage.getItem(storageKey)
    if (lastComponentFailure && lastComponentFailure > Date.now() - 60e3) {
      Store.dispatch(DISPLAY_NOTIFICATION, {
        type: 'error',
        message: 'Failed to load a required ressource.  Please refresh in a few minutes.',
      })
    } else {
      localStorage.setItem(storageKey, Date.now())
      window.location.reload()
    }
    return EmptyComponent
  })
}
